import { countryMap } from '../../../../../../../helpers/country';
import { isValidPhone, isValidEmail } from '../../../../../../../helpers/regexp';
import { validate } from '../../../../../../../helpers/validate';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useManagerStore } from '../../../../../../../store/use-manager-store';

export const useProfileSocials = () => {
  const { managerProfile, handleUpdateManagerProfile, handleSaveManagerProfile } = useManagerStore();
  const { t } = useLang();

  const countryResponse = managerProfile?.country;

  const handleSubmit = () => {
    const isValid = validate({
      surname: { rule: () => !!managerProfile?.last_name },
      name: { rule: () => !!managerProfile?.first_name },
      country: { rule: () => !!managerProfile?.country },
      region: { rule: () => !!managerProfile?.area },
      city: { rule: () => !!managerProfile?.city },
      phone: { rule: () => isValidPhone(managerProfile?.phone) },
      email: { rule: () => isValidEmail(managerProfile?.email) },
    });
    if (!isValid) return;
    handleSaveManagerProfile();
  };

  return {
    firstname: managerProfile?.first_name,
    secondname: managerProfile?.second_name,
    lastname: managerProfile?.last_name,
    country: countryResponse
      ? {
          id: countryResponse,
          value: countryMap[countryResponse],
        }
      : undefined,
    region: managerProfile?.area,
    city: managerProfile?.city,
    phone: managerProfile?.phone,
    email: managerProfile?.email,
    handleUpdateManagerProfile,
    t,
    handleSubmit,
  };
};
